// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".most-viewed__item[data-v-18597fec]{width:320px;margin-right:20px}.most-viewed__item[data-v-18597fec]:last-child{margin-right:0}.most-viewed__item[data-v-18597fec] .category{margin:12px 0 22px}@media (max-width:1023px){.most-viewed__item[data-v-18597fec]{width:100%}.most-viewed__item[data-v-18597fec]:last-child{margin-right:30px}}.most-viewed__wrapper .most-viewed__item-text[data-v-18597fec]{display:block;height:44px;overflow:hidden}", ""]);
// Exports
module.exports = exports;
